import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {handleSeerchAndPage} from "../../../../utils/Utils";
import {message} from 'antd';
import dl from './image/动力总成.png'
import dlfj from './image/动力系统附件.png'
import lhq from './image/离合器及变速器.png'
import xg from './image/悬架转向及制动.png'
import cs from './image/车身.png'
import nw from './image/内外饰件及座椅.png'
import dq from './image/电器.png'
import kt from './image/空调及气囊.png'
import qt from './image/附件及其它.png'
import rj from './image/软件.png'

class frontFaultDiagnosisStore {
    @observable loading
    @observable carSeries
    @observable system
    @observable faultCode
    @observable phenomenon
    @observable standard
    @observable fault
    @observable pagination
    @observable showFilter
    @observable defaultStatus
    @observable riceExportArg
    @observable searchExportArg
    @observable exportBtn
    @observable detailLoading
    @observable collectStatues
    @observable collectList
    @observable collectPagination
    @observable standardArg
    @observable contentListPage //标准内容详情列表
    @observable standardContentList //标准内容详情列表
    @observable contentLoading //
    @observable tabLoading //

    constructor() {
        this.loading = false
        this.carSeries = []  //车系
        this.system = []  //系统
        // this.system = [{
        //     "id": "d1e72db6-b9f7-4f42-aac1-8b1a9fcd096f",
        //     "name": "动力总成",
        //     "sort": 1,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679987457000,
        //     "isDelete": 0,
        //     "imageUrl": dl
        // }, {
        //     "id": "e7a81629-d0b7-42ef-b8c6-fa8f55763fe3",
        //     "name": "动力系统附件",
        //     "sort": 2,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679987474000,
        //     "isDelete": 0,
        //     "imageUrl": dlfj
        // }, {
        //     "id": "c8281d11-6061-4ec3-afca-7aa48c3d1a72",
        //     "name": "离合器及变速器",
        //     "sort": 3,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679713170000,
        //     "isDelete": 0,
        //     "imageUrl": lhq
        // }, {
        //     "id": "41ed1db1-4203-427d-8366-3d883bfe4b3d",
        //     "name": "悬架转向及制动",
        //     "sort": 4,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679705130000,
        //     "isDelete": 0,
        //     "imageUrl": xg
        // }, {
        //     "id": "216ab2d3-dc75-470b-8dfd-61f882167d47",
        //     "name": "车身",
        //     "sort": 5,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679903393000,
        //     "isDelete": 0,
        //     "imageUrl": cs
        // }, {
        //     "id": "431bc49c-6385-4a70-b200-b9a76b151c43",
        //     "name": "内外饰件及座椅",
        //     "sort": 6,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679705149000,
        //     "isDelete": 0,
        //     "imageUrl": nw
        // }, {
        //     "id": "0e84b05b-eb8b-4064-b429-cc0b944a2a79",
        //     "name": "电器",
        //     "sort": 7,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679705191000,
        //     "isDelete": 0,
        //     "imageUrl": dq
        // }, {
        //     "id": "4c822a9b-f1b0-4002-a4f9-1c6c3e9db14d",
        //     "name": "空调及气囊",
        //     "sort": 8,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679705203000,
        //     "isDelete": 0,
        //     "imageUrl": kt
        // }, {
        //     "id": "9f212a8f-cf13-48b5-a3ad-74ad9dfb9dd1",
        //     "name": "附件及其它",
        //     "sort": 9,
        //     "createTime": 1677119769000,
        //     "updateTime": 1679705212000,
        //     "isDelete": 0,
        //     "imageUrl":qt
        // }, {
        //     "id": "5f2e2cc2-38ba-4664-8e90-ba80b107bc08",
        //     "name": "软件",
        //     "sort": 10,
        //     "createTime": 1677120322000,
        //     "updateTime": 1679987443000,
        //     "isDelete": 0,
        //     "imageUrl": rj
        // }]
        this.faultCode = []  //故障码
        this.phenomenon = []  // 现象
        this.standard = []  //标准
        this.fault = []  //故障
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.showFilter = true  //MEnu菜单卡片显示状态 true:收起  false:显示
        this.defaultStatus = 0 //是否显示table表 默认状态 0是显示表格  点击筛选菜单显示 1  收藏列表显示2  标准显示3
        this.riceExportArg = {} //筛选导出参数
        this.searchExportArg = '' //搜索导出参数
        this.exportBtn = ''  //导出按钮名称显示
        this.detailLoading = false  //内页显示loading
        this.collectStatues = false  //收藏显示状态
        this.collectList = []  //收藏列表
        this.collectPagination = {
            current: 0,
            total: 1,
            pageSize: 20
        }
        this.standardArg = {}//保存点击标准时当前三个状态
        this.contentListPage = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.contentLoading=false
        this.standardContentList=[]
        this.tabLoading=false

    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    //获取车型列表
    @action
    carSeriesList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/frontDeskForCarList`)
        runInAction(() => {
            this.carSeries = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }

    //获取故障列表
    @action
    faultList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/faultListForeground`)
        runInAction(() => {
            this.fault = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }

    //获取系统列表
    @action
    systemList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseSystem/systemListForeground`)
        runInAction(() => {
            this.system = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }

    //获取故障码列表
    @action
    faultCodeList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseErrorCode/faultCodeListForeground`)
        runInAction(() => {
            this.faultCode = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }

    //获取现象列表
    @action
    phenomenonList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/phenomenonListForeground`)
        runInAction(() => {
            this.phenomenon = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }


    //获取标准列表
    @action
    standardList = async (page) => {
        this.tabLoading=true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/standardListForeground`)
        runInAction(() => {
            this.standard = Array.isArray(res) ? res : []
            this.tabLoading=false
        })
    }

    //保存筛选参数，以便分页
    @action
    saveBreadcrumbArr=(obj)=>{
        this.searchList=obj
        this.getList(1,obj)
    }

    //根据筛选获取初始化列表
    @action
    getList = async (page, search) => {
        this.loading = true
        this.riceExportArg = search
        this.searchExportArg = ''
        this.exportBtn = '筛选导出'
        let searchResult = handleSeerchAndPage(page, this.pagination, this.searchList) //多条件分页的轮子
        searchResult.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/foregroundQueryPageList`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.contentList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements ? res.totalElements : 0} 条`
            }
            this.loading = false
        })
    }

    //保存搜索框值，双向 绑定
    @action
    saveSearchInputArg = (value) => {
        this.searchExportArg = value
    }

    //根据搜索获取初始化列表
    @action
    getSearchList = async () => {
        this.loading = true
        this.riceExportArg = {}
        this.exportBtn = '搜索导出'
        let search = {searchValue: this.searchExportArg}
        let searchResult = handleSeerchAndPage(1, this.pagination, search) //多条件分页的轮子
        searchResult.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/searchForegroundList`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.contentList = res.content ? res.content : []
            this.defaultStatus = 1
            this.showFilter = true
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements ? res.totalElements : 0} 条`
            }
            this.loading = false
        })
    }


    //单条查询
    @action
    getDetailContent = async (id) => {
        this.detailLoading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/queryTheEntireContentAccordingToItsId/${id}`)
        runInAction(() => {
            this.detailContent = res ? res : {}
            this.collectStatues = res.collect
            this.detailLoading = false
        })
    }

    //收藏和取消收藏
    @action
    startCollect = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/bookmarkAndUnbookmark?id=${id}`)
        if (res.status) {
            runInAction(() => {
                message.success(res.data)
                this.collectStatues= !this.collectStatues
            })
        }

    }

    //获取收藏列表
    @action
    getCollectList = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/favoritesListForeground`)
        runInAction(() => {
            this.collectList = res ? res.content  :[]
            this.collectPagination = {
                current: res.number + 1,
                total: res.totalElements,
                pageSize: res.size,
            }
        })
    }

//    点击标准
    @action
    saveStandardArg=(item)=>{
        this.standardArg = item
        this.defaultStatus=3
        this.initContentListPage()
    }


    /** 标准获取相关信息 **/
    @action
    initContentListPage = async (page) => {
        runInAction(() => {
            this.contentLoading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteriaContent/criteriaIdQueryListPaging?criteriaId=${this.standardArg.id}`,this.contentListPage)
        if (res && res.status === 0) {
            runInAction(() => {
                this.contentLoading = false
            })
            return
        }
        runInAction(() => {
            this.contentLoading = false
            this.standardContentList = res.content || []
            this.contentListPage = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

}

export default new frontFaultDiagnosisStore()






// WEBPACK FOOTER //
// ./src/project/dongfeng/faultDiagnosis/demo/Datasource.js